"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ASSIST_REFUSALS = exports.assistListQuerySchema = exports.createAssistRequestSchema = exports.ASSIST_REQUEST_STATUSES = void 0;
const zod_1 = require("zod");
/**
 * Wave 3 — "Summon a human" (SPEC §9). The kiosk raises a request; staff see
 * it on the Devices screen through the poll they already run, then ack (on the
 * way) and resolve (handled). No customer identity crosses this wire beyond
 * the session that happened to be running — the button must work for a
 * customer who can't sign in at all, which is exactly when they need staff.
 */
exports.ASSIST_REQUEST_STATUSES = ['OPEN', 'ACKED', 'RESOLVED'];
/** The portal body is empty on purpose: device identity comes from the token. */
exports.createAssistRequestSchema = zod_1.z.object({}).strict();
exports.assistListQuerySchema = zod_1.z.object({
    status: zod_1.z.enum(exports.ASSIST_REQUEST_STATUSES).optional(),
});
/** Refusal codes the kiosk button renders inline. */
exports.ASSIST_REFUSALS = ['too_many_attempts'];
//# sourceMappingURL=assist.js.map